// extracted by mini-css-extract-plugin
module.exports = {"tools":"ProjectInfo_tools__38ZOn","quick_info":"ProjectInfo_quick_info__2F4Jx"};